module.exports = __webpack_public_path__ + "74482a12aefc45e987b69c05095c0733.svg";